export default "__VITE_ASSET__Dqz5whEw__"